import { LoginMethodTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useEffect } from "react";
import SvgAuthMail from "./auth-tabs-icons/SvgAuthMail";
import SvgAuthPhone from "./auth-tabs-icons/SvgAuthPhone";
import * as ls from "@/utils/functions/app-local-storage";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  btnIndex?: LoginMethodTypes;
  setBtnIndex: (index: LoginMethodTypes) => void;
}

const AuthTabs: React.FC<Props> = ({ btnIndex, setBtnIndex }) => {
  const t = useTranslation();

  useEffect(() => {
    const byPhone = !!ls.get(ls.Keys.userSignInMobile);
    const byEmail = !!ls.get(ls.Keys.userSignInEmail);
    const both = byEmail && byPhone;

    setBtnIndex(
      !both && byEmail ? LoginMethodTypes.by_email : LoginMethodTypes.by_phone,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    {
      index: LoginMethodTypes.by_email,
      Svg: SvgAuthMail,
      label: t.e_mail ?? t["e-mail"],
    },
    { index: LoginMethodTypes.by_phone, Svg: SvgAuthPhone, label: t.phone },
  ];
  return (
    <div className="auth-tabs-container">
      {tabs.map((tab) => (
        <button
          key={tab.index}
          className={`tab ${
            tab.index === btnIndex ? "tab-selected" : "tab-not-selected"
          }`}
          onClick={() => setBtnIndex(tab.index)}
        >
          <tab.Svg selected={tab.index === btnIndex} />
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;
